import type { Meta, StoryObj } from "@storybook/react";
import Card from "../components/Cards/Card";

const meta = {
    title: "Example/Card",
    component: Card,
    argTypes: {
        backgroundColor: { control: "color" },
    },
} as Meta;
export default meta;
type Story = StoryObj<typeof meta>;

export const CardLgWithImg: Story = {
    args: {
        width: "w-76 lg:w-300 md:w-300",
        height: "h-180 lg:h-122  md:h-122",
        buttonPlacement: " justify-start",
        imageSize: "md:w-340 md:h-82 lg:w-340 lg:h-82 w-70 h-73",
        title: "Stabilität macht glücklich",
        textSize: "line-clamp-6 md:line-clamp-4 lg:line-clamp-4 overflow-ellipsis",
        content:
            "Ein glücklicher Mensch ist für mich jemand, der in seinem Leben steht, an dem Punkt, wo er stehen will. Oder mit dem Punkt, wo er steht, umgehen kann und für sich zufrieden ist und eigentlich auch mit dem zufrieden ist, was er hat.",
    },
};

export const CardSm: Story = {
    args: {
        width: "w-74.5 lg:w-84 justify-center items-center ",
        height: "lg:h-84 h-64",
        hasImage: true,
        hasText: false,
        titleSize: "text-center lg:text-2xl text-xl",
        title: "Einzelgespräch",
        hasContent: false,

        buttonPlacement: "justify-center pt-2",
        imageSize: "h-20 w-full",
        border: "",
        titlePlacement: "text-center",
        paddings: "",
        spacing: "-space-y-6",
    },
};
export const CardHigh: Story = {
    args: {
        width: "w-76 lg:w-99",
        height: "lg:h-190 h-192",
        imageSize: " lg:w-88 lg:h-55 w-70 h-73",
        textSize: "leading-loose line-clamp-4  lg:line-clamp-4",
        title: "Hochsensibilität: Tipps und Umgang",
        content:
            "Bei Hochsensibilität gibt es verschiedene Tipps, die dir zeigen sollen, wie du dich abgrenzen kannst. Viele sehen sie als eine Gabe an. Es steckt jedoch etwas anderes dahinter. Hochsensible Menschen reagieren auf Reize, die ihr System nur schwer verarbeiten kann.",
    },
};
export const CardMdNoButton: Story = {
    args: {
        width: "w-80 lg:w-120 md:w-98",
        height: " min-h-[467px] pb-6",
        title: "Burnout",
        content:
            "Ein Burnout ist eine massive emotionale und körperliche Erschöpfung, die weniger durch die Arbeit und vielmehr durch den Umgang entsteht.",
        contentSize: " lg:leading-6.5 lg:text-xl1 leading-7 text-lg",
        hasButton: false,
        hasImage: true,
        imageSize: "lg:w-84 lg:h-55 w-68 h-55",
        border: "border-gray-100",
        textSize: "line-clamp-6 lg:line-clamp-none",
    },
};
export const CardIconSm: Story = {
    args: {
        width: "lg:w-82 w-80",
        height: "h-54",
        hasImage: true,
        hasButton: false,
        imageSize: "h-20 w-20 ",
        title: "8,000+",
        titleSize: "text-center text-xl3 ",
        textSize: "text-xl1 text-center",
        content: "Menschen begleitet",
        contentSize: "text-center text-lg leading-5",
    },
};

export const CardMdHighNoButton: Story = {
    args: {
        width: "lg:w-98 md:w-98 w-76",
        height: "min-h-162 py-6",
        hasImage: true,
        imageSize: "lg:w-84 lg:h-55 md:w-84 md:h-55  w-70 h-73",
        title: "Ich arbeite da, wo du nicht kannst",
        content:
            "Viele Blockaden kannst du durch Selbstfürsorge lösen. Manchmal gibt es aber auch Gründe, warum du dich selbst nicht unterstützen kannst. In diesen Fällen arbeite ich gezielt an den Ursachen im Energiefeld, die du nicht alleine lösen kannst.",
        hasButton: false,
        border: "border-4 border-zinc-100",
        backgroundColor: "bg-white",
        textSize: "line-clamp-6 lg:line-clamp-none",
    },
};
export const CardMdWithButton: Story = {
    args: {
        width: "lg:w-98 w-76",
        height: " lg:h-110 h-128",
        imageSize: "lg:w-84 lg:h-55 w-70 h-73",
        title: "Keine Energieübertragung",
        content:
            "Das Energiefeld erleidet Schaden durch seelische Manipulation, da diese im Gegensatz zur natürlichen Funktionsweise steht.",
        border: "",
    },
};
export const CardLgColor: Story = {
    args: {
        width: "lg:w-320 w-83",
        height: " min-h-220 pb-6",
        imageSize: "lg:w-300 lg:h-120 w-74 h-42",
        title: "Seelische Widerstandsfähigkeit",
        content:
            "Das Geheimnis seelischer Widerstandsfähigkeit wird in diesem Vortrag sichtbar!Seelische Widerstandsfähigkeit ist kein Zufall, sie unterliegt einem Mechanismus. Erkennt man dies, lässt sich gezielt an der eigenen Widerstandsfähigkeit oder Resilienz arbeiten. Nicht jeder Mensch ist seelisch widerstandsfähig, aber jeder Mensch kann seelisch widerstandsfähiger werden!",
        buttonPlacement: "lg:justify-end justify-center",
        border: "",
    },
};

export const CardMdColor: Story = {
    args: {
        width: "lg:w-146 w-83",
        height: "lg:h-62 min-h-84 pb-5",
        hasImage: false,
        hasButton: false,
        title: "Die eigene Energie ist die Beste",
        titleSize: "text-center text-2xl ",
        content:
            "Unsere Energie hat eine einzigartige Signatur, genau darum kann nur die eigene Energie mit eben dieser einzigartiger Signatur optimal verarbeitet werden.  Fremdenergie enthält Komponenten, die nicht richtig interpretiert werden können. Das führt zu Funktionsstörungen im Energiefeld.",
        contentSize: "text-center text-xl1 lg:leading-8.5 leading-7",
        border: "",
    },
};

export const CardSmIconNoButton: Story = {
    args: {
        width: "lg:w-82 w-83",
        height: "lg:h-62 h-53",
        hasImage: true,
        imageSize: " h-25 w-25",
        title: "Energiefeldsignatur",
        titleSize: "text-center text-2xl",
        content: "Wie ein Fingerabdruck",
        contentSize: "text-center text-xl1 lg:leading-8.5 leading-7",
        hasButton: false,
    },
};
export const CardIconColor: Story = {
    args: {
        width: "lg:w-100 md:w-83 w-83",
        height: "min-h-130 pb-6",
        hasImage: true,
        imageSize: " h-25 w-25",
        title: "Meine Faszination wächst unaufhörlich",
        titleSize: "text-center text-2xl",
        content:
            "Meine grösste Leidenschaft gehörte schon immer der Erforschung von Energiefeldern und ihren Mechanismen zur Wiederherstellung der natürlichen Funktionsfähigkeit. Sie führt dazu, dass die eigene Kraft nachhaltig aufgebaut werden kann. ",
        contentSize: "text-center text-xl1 lg:leading-8.5 leading-7",
        buttonPlacement: "justify-center",

        border: "",
    },
};

export const TextCard: Story = {
    args: {
        width: "w-[320px] lg:w-[724px] md:w-[724px]  ",
        height: " min-h-[540px] pb-6 md:pb-0 lg:pb-0",
        hasButton: false,
        hasImage: false,
        border: "",
        backgroundColor: "bg-yellow",
        title: "Ich gebe kein Heilsversprechen",
        titleSize:
            "text-[40px] lg:text-[80px] lg:leading-[88px] leading-[52px]  break-all lg:break-normal",
        content: [
            "Ich bleibe mit voller Absicht den Beweis schuldig, dass meine Arbeit wirkt. Es gibt sehr viele Menschen, die von meiner Arbeit profitieren konnten. Es gibt aber auch Menschen, die es nicht spüren konnten und das ist in Ordnung. Man kann nicht immer allen Menschen helfen, auch wenn man es möchte. Darum gebe ich keine Versprechen, was den Erfolg meiner Arbeit anbelangt. ",
            "Ich gebe mein Bestes, anhand meiner Forschungsarbeiten und der daraus resultierenden Energiefeldmechanik, präzise am Energiefeld zu arbeiten und die Ursachen für Probleme zu lösen. ",
            "Wenn die Energiefelder funktionieren, dann funktioniert das Leben und macht auch wieder Spass.",
        ],
        hasPretitle: true,
        pretitle: " Mein Bestes geben",
        pretitleSize: "text-[28px] lg:text-xl3 italic",
        contentSize: " text-lg lg:text-xl1 leading-loose lg:leading-8.5 ",
    },
};
export const TextCardSm: Story = {
    args: {
        width: "lg:w-[420px]  w-[351px]",
        height: "lg:h-[650px]  h-[480px]",
        hasButton: true,
        hasImage: false,
        backgroundColor: "bg-turquoise",
        title: "Ich bin locker drauf, aber meine Werte sind unerschütterlich!",
        content:
            "Ich lege grossen Wert auf eine exakte Arbeitsweise und hohe Qualität. Anhand meiner Forschungsarbeit lehne ich Energieübertragung und jegliche Manipulationen ab. ",
        buttonPlacement: "justify-start",
        border: "",
        titleSize: "text-xl3",
    },
};
export const CardSmTuqouise: Story = {
    args: {
        width: "lg:w-[604px] w-[351px]",
        height: " lg:h-[674px] h-[572px]",
        backgroundColor: "bg-turquoise",
        hasImage: true,
        imageSize: "w-[303px] h-[188px] lg:w-[380px] lg:h-[232px]",
        title: "Schnell und einfach im online Kundenprtal:",
        titleSize: "text-2xl lg:text-xl3 lg:leading-10 leading-loose",
        content: "Unkompliziert buchen und anpassen, egal um welche Uhrzeit. ",
        border: "",
        hasButton: true,
    },
};
